exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-stripe[data-v-7beb6702]  {\n    background-color:rgba(0,0,0,.05);\n}\n.detail-row > td[data-v-7beb6702] {\n    border: none;\n    padding: 0;\n}\n.status-icon[data-v-7beb6702] {\n    position: relative;\n    top: -3px;\n}\n.icon-hidden[data-v-7beb6702] {\n    color: transparent;\n}    \n", ""]);

// exports
